import React from 'react';
import { Section } from './ui/Section';
import { CheckIcon } from 'lucide-react';
export function SolutionSection() {
  const learnings = ['Por qué tu cerebro guarda los peores pensamientos para la hora de dormir', "Cómo detener la 'Espiral de la Mujer Responsable' (planificar ≠ paz)", 'Un método de 4 fases que enseña a tu sistema nervioso a esperar la calma', 'El protocolo exacto para los despertares de 2–4am', 'Un plan de 7 días listo para usar que construye consistencia', 'Soluciones para días de estrés, viajes y semanas hormonales'];
  return <Section dark={false} className="bg-cream-50" data-id="element-215">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-216">
        <span className="text-gold-600 font-bold tracking-widest uppercase text-xs mb-4 block" data-id="element-217">
          Presentamos
        </span>
        <h2 className="text-4xl md:text-5xl font-serif text-navy-900 mb-6" data-id="element-218">
          El Libro Digital Sueño y Serenidad <br data-id="element-219" />
          <span className="italic text-navy-700" data-id="element-220">para Mujeres de 40+</span>
        </h2>
        <p className="text-xl text-navy-700/80 leading-relaxed" data-id="element-221">
          Una guía práctica y sin misticismo para acabar con los ciclos de
          ansiedad nocturna y recuperar el sueño profundo—sin medicamentos,
          rutinas extremas ni días perfectos.
        </p>
      </div>

      <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-cream-200 max-w-4xl mx-auto" data-id="element-222">
        <h3 className="text-2xl font-serif text-navy-900 mb-8 text-center" data-id="element-223">
          Lo que aprenderás en este libro digital
        </h3>
        <div className="grid md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-224">
          {learnings.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-225">
              <div className="flex-shrink-0 mt-1" data-id="element-226">
                <div className="w-6 h-6 rounded-full bg-gold-100 flex items-center justify-center" data-id="element-227">
                  <CheckIcon className="w-4 h-4 text-gold-600" data-id="element-228" />
                </div>
              </div>
              <p className="text-navy-800 leading-snug" data-id="element-229">{item}</p>
            </div>)}
        </div>
      </div>
    </Section>;
}